import { AfterContentInit, Component, ContentChildren, DestroyRef, inject, Input, QueryList } from '@angular/core';
import { TimelineItemComponent } from './timeline-item/timeline-item.component';
import { NgClass } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'mwe-timeline',
  templateUrl: './timeline.component.html',
  imports: [NgClass],
})
export class TimelineComponent implements AfterContentInit {
  @Input() showLine = true;
  @ContentChildren(TimelineItemComponent) timelineItems!: QueryList<TimelineItemComponent>;

  private readonly destroyRef = inject(DestroyRef);

  ngAfterContentInit(): void {
    this.updateItemIndexes();
    this.timelineItems.changes.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => this.updateItemIndexes());
  }

  private updateItemIndexes(): void {
    this.timelineItems.forEach((item, index) => {
      item.index = index + 1;
    });
  }
}
